import SidebarFilter from './components/SidebarFilter/SidebarFilter';

const TipComponent = () => {
    return (
        <div className='Container'><SidebarFilter /></div >
    );
};

export default TipComponent;
